import React, { useEffect, useState } from 'react'
import { Avatar, Dialog, DialogContent, DialogTitle, IconButton, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Tooltip } from '@material-ui/core'
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import SettingsIcon from '@material-ui/icons/Settings';
import ParkService from '../ParkService'

const ComplexModal = ({ complex, setComplex }) => {
  const [complexes, setComplexes] = useState([])
  const [open, setOpen] = useState(false)

  const toggleOpen = () => setOpen(p => !p)

  const handleSelect = (item) => {
    setComplex(item);
    toggleOpen()
  }

  useEffect(() => {
    ParkService.getComplexes()
      .then((res) => {
        setComplexes(res)
        setOpen(true)
      })
  }, [])
  return (
    <div className='d-flex justify-content-end'>
      <Tooltip title='configuración'>
        <IconButton onClick={toggleOpen}>
          <SettingsIcon />
        </IconButton>
      </Tooltip>
      <Dialog open={open} onClose={toggleOpen} fullWidth maxWidth='sm' scroll='paper'>
        <DialogTitle>Puntos de parqueo</DialogTitle>
        <DialogContent dividers>
          <List>
            {complexes.map(item => (
              <ListItem key={item.id} selected={complex?.id === item.id}>
                <ListItemAvatar>
                  <Avatar src={item.imagen} />
                </ListItemAvatar>
                <ListItemText
                  primary={item.nombre}
                />
                <ListItemSecondaryAction>
                  <IconButton edge="end" aria-label="select" onClick={() => handleSelect(item)}>
                    {complex?.id === item.id
                      ? <CheckCircleIcon />
                      : <RadioButtonUncheckedIcon />
                    }
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default ComplexModal